import React, {useEffect, useState} from 'react';
import {TextField} from '@material-ui/core';
import {useHistory} from "react-router-dom";
import {callApi, callEmptyParamsApi} from "../../../connection/ClientApi";
import IconTitleButton from "components/buttons/IconTitleButton";
import {toEnglishNumber} from "components/utils/StringUtility";
import Autocomplete from '@material-ui/lab/Autocomplete';
import StandardButtonFit from "../../../components/buttons/StandardButtonFit";
import {basketViewModel} from '../../../viewModels/Basket.viewModel';
import {IsLP_MP_SP, IsNotM_SM} from "my-styles/media/media";
import Urls from "../../../connection/Urls";
import messages from 'res/messages/farsi'

import ICNotification from "res/images/notification.png";
import ICBag from "res/images/bag.png";
import ICBasket from "res/images/basket.png";
import ICClear from "res/images/clear.png";
import ICUserAccount from "res/images/user.png";
import ICCategory from 'res/images/category.png';
import ICSearch from 'res/images/magnifire.png';
import ICLogo from 'res/images/logo_persian.png';
import ICReward from 'res/images/reward.png';
import ICMail from "res/images/message.png";
import ICWalllet from '@mui/icons-material/AccountBalanceWalletOutlined';

export default function Toolbar(props) {

    const history = useHistory()

    const [isCancelled, setIsCancelled] = useState(false)
    const [key, setKey] = React.useState(1)
    const [searchResults, setSearchResults] = useState([])
    const [searchValue, setSearchValue] = useState("")
    const [basketCount, setBasketCount] = useState(0)
    const [notifCount, setNotifCount] = useState("")

    const onSearch = (e) => {
        setSearchValue(e.target.value)
        requestSearchResult(e.target.value)
    }

    function requestSearchResult(searchText) {
        if (!searchText || searchText.length < 2) {
            setSearchResults([])
            return
        }

        let params = new FormData()
        params.append("text", toEnglishNumber(searchText))
        callApi(Urls.getSearchAvailableItems, params, (data) => {
            let searchResults = []
            if (data.list) {
                data.list.forEach(searchResult => {
                    searchResults.push({
                        parentId: searchResult.parent_id,
                        categoryId: searchResult.category_id,
                        name: searchText + messages.inCategory + searchResult.name,
                        key: searchText
                    })
                })
            }
            searchResults.push({
                parentId: -1,
                categoryId: -1,
                name: messages.showAllSearchFor + searchText,
                key: searchText
            })
            setSearchResults(searchResults)
        }, () => {
            setSearchResults([])
        }, () => {

        }, () => {

        })
    }

    function requestNotificationCount() {
        callEmptyParamsApi(Urls.getUnreadNotificationsCount, (data) => {
            if (isCancelled) return

            if (data.description === 200) {
                if (data.count === 0)
                    setNotifCount(undefined)
                else
                    setNotifCount(data.count)
            } else {
                setNotifCount(undefined)
            }
        }, () => {

        }, () => {

        }, () => {

        })
    }

    function getAccountButton() {
        if (IsLP_MP_SP()) {
            return <td className="paddingLeft_1" onMouseEnter={props.onShowProfileMenu}
                       onMouseLeave={props.onHideProfileMenu}>
                <StandardButtonFit
                    icon={<img alt={"صرفه مارکت"} src={ICUserAccount} className="xSmallIcon"/>}
                    onClick={props.onShowLoginPage}/>
            </td>
        } else {
            return <td className="paddingLeft_1">
                <StandardButtonFit
                    icon={<img alt={"صرفه مارکت"} src={ICUserAccount} className="xSmallIcon"/>}
                    onClick={props.onShowSideMenu('left', true)}/>
            </td>
        }
    }

    function getCategoryButton() {
        if (IsLP_MP_SP()) {
            return <IconTitleButton
                onMouseEnter={props.onShowCategoryMenu}
                onMouseLeave={props.onHideCategoryMenu}
                fontSize="mediumTextBold"
                textcolor="var(--gray_7)"
                icon={<img alt={"صرفه مارکت"} src={ICCategory} className="xSmallIcon"/>}
                title={messages.category}/>
        } else {
            return <IconTitleButton
                fontSize="mediumTextBold"
                textcolor="var(--gray_7)"
                icon={<img alt={"صرفه مارکت"} src={ICCategory} className="xSmallIcon"/>}
                title={messages.category}
                onClick={props.onShowCategoryPage}/>
        }
    }

    function getLogo() {
        return <img className="clickable appLogo"
                    src={ICLogo} alt=""
                    onClick={props.onShowMainPage}/>
    }

    function getSearchBox() {
        return <div className="searchInputBoxContainer">
            <center className="fullWidth">
                <div className="searchInputBox">
                    <img alt={"صرفه مارکت"} src={ICSearch} className="marginSmall xSmallIcon"/>
                    <Autocomplete
                        key={key}
                        freeSolo
                        disableClearable
                        style={{width: "100%"}}
                        options={searchResults}
                        getOptionLabel={(option) => option.name}
                        onChange={(e, value) => {
                            if (value.categoryId > 0) {
                                props.onNavigate(history, '/category?c=' + value.categoryId + "&p=1")
                            } else if (value.key) {
                                props.onNavigate(history, '/category?searchText=' + value.key + "&p=1")
                            } else {
                                props.onNavigate(history, '/category?searchText=' + searchValue + "&p=1")
                            }
                            setKey(Math.random() * 1000)
                            setSearchValue("")
                            setSearchResults([])
                        }}
                        renderInput={(param) =>
                            <TextField
                                {...param}
                                onChange={onSearch}
                                placeholder={messages.search}
                                className={"transparent center fullHeight"}
                                InputProps={{
                                    ...param.InputProps, disableUnderline: true,
                                    endAdornment: searchValue !== "" && (
                                        <img alt={"صرفه مارکت"} src={ICClear} className="marginSmall xxxxSmallIcon grayColor"
                                             onClick={() => {
                                                 setKey(Math.random() * 1000)
                                                 setSearchResults([])
                                                 setSearchValue('')
                                             }}/>
                                    )
                                }}
                            />
                        }
                    />
                </div>
            </center>
        </div>
    }

    function getMenu() {
        return <div className="horizontalScreen">
            {getCategoryButton()}
            <IconTitleButton
                fontSize="mediumTextBold"
                textcolor="var(--gray_7)"
                icon={<img alt={"صرفه مارکت"} src={ICBag} className="xSmallIcon"/>}
                title={messages.myOrders}
                onClick={props.onShowOrdersPage}/>
            <IconTitleButton
                fontSize="mediumTextBold"
                textcolor="var(--gray_7)"
                icon={<img alt={"صرفه مارکت"} src={ICReward} className="xSmallIcon"/>}
                title={messages.myRewards}
                onClick={props.onShowRewardsPage}/>
            {IsNotM_SM() &&
            <IconTitleButton
                fontSize="mediumTextBold"
                textcolor="var(--gray_7)"
                icon={<ICWalllet className="xSmallIcon"/>}
                title={messages.wallet}
                onClick={props.onShowWalletPage}/>
            }
            {IsNotM_SM() &&
            <IconTitleButton
                fontSize="mediumTextBold"
                textcolor="var(--gray_7)"
                icon={<img alt={"صرفه مارکت"} src={ICMail} className="xSmallIcon"/>}
                title={messages.criticsAndSuggestion}
                onClick={props.onShowSuggestionPage}/>
            }
        </div>
    }

    useEffect(() => {
        requestNotificationCount()
        basketViewModel.getBasketCount()
        basketViewModel.basketCount.subscribe((count) => {
            if (isCancelled) return

            setBasketCount(count)
        })

        return () => {
            setIsCancelled(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (<div className="shadow fullWidth highZIndex_1" style={{
        backgroundColor: "white",
        position: "fixed",
        overflow: "hidden",
        top: props.bannerHeight && props.bannerHeight>0 ? props.bannerHeight : 0
    }}>
        <div className="tollbar_container paddingTopSmall">
            <table>
                <tbody>
                <tr>
                    <td>
                        {getLogo()}
                    </td>
                    <td className="fullWidth marginLeftRightSmall">
                        {getSearchBox()}
                    </td>
                    {getAccountButton()}
                    <td className="paddingLeft_1">
                        <StandardButtonFit
                            icon={<img alt={"صرفه مارکت"} src={ICNotification} className="xSmallIcon"/>}
                            badgenumber={
                                notifCount >= 9 ? "+9" : notifCount
                            }
                            onClick={props.onShowNotificationPage}/>
                    </td>
                    <td className="paddingLeft_1">
                        <StandardButtonFit
                            icon={<img alt={"صرفه مارکت"} src={ICBasket} className="xSmallIcon"/>}
                            badgenumber={
                                basketCount >= 9 ? "+9" : basketCount
                            }
                            onClick={props.onShowBasketPage}/>
                    </td>
                </tr>
                </tbody>
            </table>
            {getMenu()}
        </div>
    </div>)

}